module.exports = __webpack_public_path__ + "static/media/triviago.a2646468.jpg";